import { Tenant } from '../types';

export function get99dUrl(tenant: Tenant, relativePath: string): string {
    return tenant === Tenant.NinetyNineDesigns
        ? relativePath
        : `https://99designs.com${relativePath}`;
}
